/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer5_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer" | "ReplyListContainer6_viewer">;
    readonly " $refType": "ReplyListContainer5_viewer";
};
export type ReplyListContainer5_viewer$data = ReplyListContainer5_viewer;
export type ReplyListContainer5_viewer$key = {
    readonly " $data"?: ReplyListContainer5_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer5_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer5_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer6_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '1360af393a016cbf8c50dd82afa5e4c6';
export default node;
